import * as React from "react";
import { Card,Col, Container, Row } from "reactstrap";
import { LanguageSelector } from "../../i18n/LanguageSelector";
import "./EospPageContent.scss";
import CenteredContent from "./CenteredContent";

/**
 * Obsah stránky s logem a přepínám jazyků.
 */
export class EospPageContent extends React.Component<any> {
  render() {
    const { className, children } = this.props;
    let clsName = "main-col centered-block mx-auto p-0 px-sm-3";

    if (className) {
      clsName += " " + className;
    }

    return (
      <CenteredContent className={"eosp-page-content"}>
        <Col md={11} lg={9} xl={7} className={clsName}>
          <LanguageSelector />
          <Card className="border-0 px-4 py-4 mt-1">
                    {children}
                </Card>
        </Col>
      </CenteredContent>
    );
  }
}
